// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__ZE1Af","modal":"styles_modal___HIMt","content":"styles_content__z9RTy","overlayHeader":"styles_overlayHeader__kzUJ2"};